var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8917_8130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C12.0333 30 9.13319 29.1203 6.66645 27.4721C4.19972 25.8238 2.27713 23.4812 1.14181 20.7403C0.00649929 17.9994 -0.290551 14.9834 0.288228 12.0737C0.867006 9.16394 2.29562 6.49119 4.39341 4.39341C6.49119 2.29562 9.16394 0.867006 12.0737 0.288228C14.9834 -0.290551 17.9994 0.00649929 20.7403 1.14181C23.4812 2.27713 25.8238 4.19972 27.4721 6.66645C29.1203 9.13319 30 12.0333 30 15C29.9957 18.9769 28.414 22.7897 25.6019 25.6019C22.7897 28.414 18.9769 29.9957 15 30ZM15 3.75001C12.775 3.75001 10.5999 4.40981 8.74984 5.64597C6.89979 6.88214 5.45785 8.63915 4.60636 10.6948C3.75488 12.7505 3.53209 15.0125 3.96617 17.1948C4.40026 19.3771 5.47171 21.3816 7.04506 22.955C8.6184 24.5283 10.623 25.5998 12.8052 26.0338C14.9875 26.4679 17.2495 26.2451 19.3052 25.3937C21.3609 24.5422 23.1179 23.1002 24.354 21.2502C25.5902 19.4001 26.25 17.225 26.25 15C26.2467 12.0173 25.0604 9.15778 22.9513 7.04871C20.8422 4.93964 17.9827 3.75332 15 3.75001Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5261 19.8698L8.53613 16.6923L13.1249 13.8186V7.83984H16.8749V15.8936L10.5261 19.8698Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8917_8130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselClockIcon);
export default __webpack_public_path__ + "static/media/carousel-clock-icon.eda79af2b31dd2e5283e8a4922e82c48.svg";
export { ForwardRef as ReactComponent };